import { backend } from "../../api";
import { getTax } from "../../utils";

export const costCalculation = async (
  currentItem,
  billingAddress,
  user,
  bindingType,
  amounts,
  count
) => {
  try {
    let {
      data: { data },
    } = await backend.post("/oauth-callback/checkout-cost-calc", {
      book: currentItem,
      deliveryType: "three_days_delivery",
      billingAddress: billingAddress,
      user: user,
      binding: bindingType,
      count,
    });

    return {
      cost: data.line_item_costs[0].total_cost_incl_tax,
      taxAmount:
        +data.line_item_costs[0].total_tax + +data.fees[0].total_cost_incl_tax,
      percentage: data.line_item_costs[0].tax_rate,
    };
  } catch (err) {
    console.log(err.response && err.response.data.data["shipping_address"]);
    return {
      cost:
        bindingType === "PB"
          ? currentItem?.price.paperback_price
          : currentItem?.price.hardcover_price,
      taxAmount:
        bindingType === "PB"
          ? getTax(amounts, currentItem, "paperback_price")
          : getTax(amounts, currentItem, "hardcover_price"),
      percentage: amounts.tax,
    };
  }
};

export const costCalculationDelivery = async (
  currentItem,
  billingAddress,
  user,
  deliveryType,
  count
) => {
  try {
    let {
      data: { data },
    } = await backend.post("/oauth-callback/checkout-cost-calc", {
      book: currentItem,
      deliveryType: deliveryType,
      billingAddress: billingAddress,
      user: user,
      binding: "CW",
      count,
    });

    return +data.shipping_cost.total_cost_incl_tax;
  } catch (err) {
    console.log(err.response);
    return currentItem.delivery[deliveryType];
  }
};

export const checkDeliveryAddress = async (
  currentItem,
  billingAddress,
  user,
  deliveryType,
  count
) => {
  try {
    let { data } = await backend.post("/oauth-callback/checkout-cost-calc", {
      book: currentItem,
      deliveryType: deliveryType,
      billingAddress: billingAddress,
      user: user,
      binding: "CW",
      count,
    });

    return 1;
  } catch (err) {
    return 0;
  }
};
